<template>
  <v-dialog v-model="statusDeleteDataRequestModal" width="1000" scrollable @click:outside="$emit('closeModal')">
    <v-card class="px-1">
      <v-card-title class="pb-0">
        <v-row>
          <v-col cols="12">
            <h3 class="font-weight-bold grey--text text--darken-3 mb-1">
              {{ title }}
            </h3>
          </v-col>
          <v-col class="d-flex subtitle-2 pt-1" cols="12">
            <section class="pr-8">
              <p class="grey--text text--darken-1">Consumidor:</p>
              <p class="grey--text text--darken-1">CPF/CNPJ:</p>
              <p class="grey--text text--darken-1">Dados solicitados:</p>
            </section>
            <section>
              <p class="font-weight-bold grey--text text--darken-2">{{ selectedRequest.name }}</p>
              <p class="font-weight-bold grey--text text--darken-2">{{ selectedRequest.document_no | cpfCnpj }}</p>
              <p class="font-weight-bold grey--text text--darken-2">{{ dataRequestLabel | hifen }}</p>
            </section>
          </v-col>
          <v-col cols="12" class="subtitle-2 pb-0">
            <h3 class="grey--text text--darken-2">{{ subTitle }}</h3>
          </v-col>
        </v-row>
      </v-card-title>
      <slot></slot>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteDataRequestModal',

  props: {
    statusDeleteDataRequestModal: {
      type: Boolean,
      required: true,
    },

    selectedRequest: {
      type: Object,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    subTitle: {
      type: String,
      required: true,
    },

    isPendingRequest: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    dataRequestLabel() {
      const deleteDataRequestKey = this.isPendingRequest ? 'pending_delete_data_request' : 'delete_data_request'
      return this.selectedRequest?.[deleteDataRequestKey]?.data
    },
  },
}
</script>
